<template>
<div id="taskManage">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'taskManage'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/taskManage/index.vue